import type { ApplePayValidationError } from '../typings/apple.types';

const isApplePayValidationError = (error: unknown): error is ApplePayValidationError => {
    if (typeof error !== 'object' || error === null) {
        return false;
    }

    const candidate = error as Partial<ApplePayValidationError>;
    return candidate.code === 'APPLE_PAY_MERCHANT_VALIDATION_FAILED' && candidate.name === 'BraintreeError';
};

export default isApplePayValidationError;
